import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import RealEstateUseCasePage from "../pages/use-cases/real-estate/page";
import FAQPage from "../pages/faq/page";
import PricingPage from "../pages/pricing/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RealEstateUseCasePage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
